!function (t, e) {
  if ("function" == typeof define && define.amd) define("Hashids", ["exports"], e);else if ("undefined" != typeof exports) e(exports);else {
    var n = {
      exports: {}
    };
    e(n.exports), t.Hashids = n.exports;
  }
}("object" == typeof globalThis ? globalThis : "object" == typeof self ? self : this, function (t) {
  "use strict";

  function e(t) {
    return function (t) {
      if (Array.isArray(t)) return t;
    }(t) || r(t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }();
  }

  function n(t) {
    return function (t) {
      if (Array.isArray(t)) {
        for (var e = 0, n = new Array(t.length); e < t.length; e++) {
          n[e] = t[e];
        }

        return n;
      }
    }(t) || r(t) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    }();
  }

  function r(t) {
    if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
  }

  t.__esModule = !0, t.unicodeSubstr = t.onlyChars = t.withoutChars = t.keepUniqueChars = t.default = void 0;

  var i = function () {
    function t(t, e, r, i) {
      if (void 0 === t && (t = ""), void 0 === e && (e = 0), void 0 === r && (r = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890"), void 0 === i && (i = "cfhistuCFHISTU"), this.salt = t, this.minLength = e, "number" != typeof e) throw new TypeError("Hashids: Provided 'minLength' has to be a number (is " + typeof e + ")");
      if ("string" != typeof t) throw new TypeError("Hashids: Provided 'salt' has to be a string (is " + typeof t + ")");
      if ("string" != typeof r) throw new TypeError("Hashids: Provided alphabet has to be a string (is " + typeof r + ")");
      var f = h(r);
      if (f.length < o) throw new Error("Hashids: alphabet must contain at least " + o + " unique characters, provided: " + f);
      this.alphabet = u(f, i);
      var d,
          p,
          v = l(i, f);
      this.seps = g(v, t), (0 === n(this.seps).length || n(this.alphabet).length / n(this.seps).length > s) && (d = Math.ceil(n(this.alphabet).length / s)) > n(this.seps).length && (p = d - n(this.seps).length, this.seps += c(this.alphabet, 0, p), this.alphabet = c(this.alphabet, p)), this.alphabet = g(this.alphabet, t);
      var b = Math.ceil(n(this.alphabet).length / a);
      n(this.alphabet).length < 3 ? (this.guards = c(this.seps, 0, b), this.seps = c(this.seps, b)) : (this.guards = c(this.alphabet, 0, b), this.alphabet = c(this.alphabet, b));
    }

    var r = t.prototype;
    return r.encode = function (t) {
      for (var e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), i = 1; i < e; i++) {
        r[i - 1] = arguments[i];
      }

      var o = "";
      return (r = Array.isArray(t) ? t : [].concat(n(null != t ? [t] : []), n(r))).length ? (r.every(f) || (r = r.map(function (t) {
        return "bigint" == typeof t || "number" == typeof t ? t : m(String(t));
      })), r.every(d) ? this._encode(r) : o) : o;
    }, r.decode = function (t) {
      return t && "string" == typeof t && 0 !== t.length ? this._decode(t) : [];
    }, r.encodeHex = function (t) {
      switch (typeof t) {
        case "bigint":
          t = t.toString(16);
          break;

        case "string":
          if (!/^[0-9a-fA-F]+$/.test(t)) return "";
          break;

        default:
          throw new Error("Hashids: The provided value is neither a string, nor a BigInt (got: " + typeof t + ")");
      }

      var e = w(t, 12, function (t) {
        return parseInt("1" + t, 16);
      });
      return this.encode(e);
    }, r.decodeHex = function (t) {
      return this.decode(t).map(function (t) {
        return t.toString(16).slice(1);
      }).join("");
    }, r._encode = function (t) {
      var e,
          r = this,
          i = this.alphabet,
          o = t.reduce(function (t, e, n) {
        return t + ("bigint" == typeof e ? Number(e % BigInt(n + 100)) : e % (n + 100));
      }, 0),
          s = e = n(i)[o % n(i).length],
          a = n(this.seps),
          h = n(this.guards);

      if (t.forEach(function (n, o) {
        var h = s + r.salt + i;
        i = g(i, c(h, 0));
        var u = p(n, i);

        if (e += u, o + 1 < t.length) {
          var l = u.codePointAt(0) + o,
              f = "bigint" == typeof n ? Number(n % BigInt(l)) : n % l;
          e += a[f % a.length];
        }
      }), n(e).length < this.minLength) {
        var u = (o + n(e)[0].codePointAt(0)) % h.length;

        if (n(e = h[u] + e).length < this.minLength) {
          var l = (o + n(e)[2].codePointAt(0)) % h.length;
          e += h[l];
        }
      }

      for (var f = Math.floor(n(i).length / 2); n(e).length < this.minLength;) {
        i = g(i, i);
        var d = n(e = c(i, f) + e + c(i, 0, f)).length - this.minLength;
        d > 0 && (e = c(e, d / 2, this.minLength));
      }

      return e;
    }, r.isValidId = function (t) {
      var e = this;
      return n(t).every(function (t) {
        return e.alphabet.includes(t) || e.guards.includes(t) || e.seps.includes(t);
      });
    }, r._decode = function (t) {
      var r = this;
      if (!this.isValidId(t)) throw new Error("The provided ID (" + t + ") is invalid, as it contains characters that do not exist in the alphabet (" + this.guards + this.seps + this.alphabet + ")");
      var i = b(t, function (t) {
        return r.guards.includes(t);
      }),
          o = n(i[3 === i.length || 2 === i.length ? 1 : 0]);
      if (0 === o.length) return [];
      var s = e(o),
          a = s[0],
          h = s.slice(1).join(""),
          u = b(h, function (t) {
        return r.seps.includes(t);
      }).reduce(function (t, e) {
        var i = t.result,
            o = t.lastAlphabet,
            s = a + r.salt + o,
            h = g(o, c(s, 0, n(o).length));
        return {
          result: [].concat(n(i), [v(e, h)]),
          lastAlphabet: h
        };
      }, {
        result: [],
        lastAlphabet: this.alphabet
      }).result;
      return this._encode(u) !== t ? [] : u;
    }, t;
  }();

  t.default = i;

  var o = 16,
      s = 3.5,
      a = 12,
      h = function h(t) {
    return Array.from(new Set(t)).join("");
  };

  t.keepUniqueChars = h;

  var u = function u(t, n) {
    var r = e(t).slice(0),
        i = e(n).slice(0);
    return r.filter(function (t) {
      return !i.includes(t);
    }).join("");
  };

  t.withoutChars = u;

  var l = function l(t, n) {
    var r = e(t).slice(0),
        i = e(n).slice(0);
    return r.filter(function (t) {
      return i.includes(t);
    }).join("");
  };

  t.onlyChars = l;

  var c = function c(t, n, r) {
    return e(t).slice(0).slice(n, void 0 === r ? void 0 : n + r).join("");
  };

  t.unicodeSubstr = c;

  var f = function f(t) {
    return "bigint" == typeof t || !Number.isNaN(Number(t)) && Math.floor(Number(t)) === t;
  },
      d = function d(t) {
    return "bigint" == typeof t || t >= 0 && Number.isSafeInteger(t);
  };

  function g(t, r) {
    var i,
        o = e(r).slice(0);
    if (!o.length) return t;

    for (var s = n(t), a = s.length - 1, h = 0, u = 0; a > 0; a--, h++) {
      u += i = o[h %= o.length].codePointAt(0);
      var l = (i + h + u) % a,
          c = [s[a], s[l]];
      s[l] = c[0], s[a] = c[1];
    }

    return s.join("");
  }

  var p = function p(t, n) {
    var r = e(n).slice(0),
        i = "";

    if ("bigint" == typeof t) {
      var o = BigInt(r.length);

      do {
        i = r[Number(t % o)] + i, t /= o;
      } while (t > BigInt(0));
    } else do {
      i = r[t % r.length] + i, t = Math.floor(t / r.length);
    } while (t > 0);

    return i;
  },
      v = function v(t, n) {
    var r = e(t).slice(0),
        i = e(n).slice(0);
    return r.map(function (t) {
      var e = i.indexOf(t);

      if (-1 === e) {
        var n = r.join(""),
            o = i.join("");
        throw new Error("The provided ID (" + n + ") is invalid, as it contains characters that do not exist in the alphabet (" + o + ")");
      }

      return e;
    }).reduce(function (t, e) {
      if ("bigint" == typeof t) return t * BigInt(i.length) + BigInt(e);
      var n = t * i.length + e;
      if (Number.isSafeInteger(n)) return n;
      if ("function" == typeof BigInt) return BigInt(t) * BigInt(i.length) + BigInt(e);
      throw new Error("Unable to decode the provided string, due to lack of support for BigInt numbers in the current environment");
    }, 0);
  },
      b = function b(t, r) {
    return e(t).slice(0).reduce(function (t, e) {
      return r(e) ? [].concat(n(t), [""]) : [].concat(n(t.slice(0, -1)), [t[t.length - 1] + e]);
    }, [""]);
  },
      y = /^\+?[0-9]+$/,
      m = function m(t) {
    return y.test(t) ? parseInt(t, 10) : NaN;
  },
      w = function w(t, e, n) {
    return Array.from({
      length: Math.ceil(t.length / e)
    }, function (r, i) {
      return n(t.slice(i * e, (i + 1) * e));
    });
  };
});